import { render, staticRenderFns } from "./figma.vue?vue&type=template&id=37dbb6ba&"
import script from "./figma.vue?vue&type=script&lang=js&"
export * from "./figma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports